//TITLE-FONT
export const STYLE_HEADING_1 = (language) => {
  if (language === "TH") {
    return " font-bold  leading-11 text-30 md:text-40-th ";
  } else {
    return " font-bold  leading-11 text-30 md:text-40 ";
  }
};

export const STYLE_HEADING_2 = (language) => {
  if (language === "TH") {
    return " font-bold text-22-th md:text-28-th md:leading-8.3 text-laudry-gray-200 ";
  } else {
    return " font-bold text-22 md:text-28 md:leading-8.3 text-laudry-gray-200 ";
  }
};

export const STYLE_HEADING_2_SELECT = (language) => {
  if (language === "TH") {
    return " font-bold text-22-th md:text-28-th md:leading-8.3 text-laudry-gray-200 ";
  } else {
    return " font-bold text-22 md:text-28 md:leading-8.3 text-laudry-gray-200 ";
  }
};

export const STYLE_HEADING_2_MD_LG =
  " font-bold text-lg md:text-28 text-laudry-gray-200 leading-8.6 my-auto";
export const STYLE_HEADING_2_MD_LG_TH =
  " font-bold text-lg-th md:text-28-th text-laudry-gray-200 leading-8.6 my-auto";

export const STYLE_HEADING_3 =
  " font-bold text-xl md:text-2xl text-laudry-gray-200 leading-6.5 ";

export const STYLE_HEADING_3_TH =
  " font-bold text-xl-th md:text-2xl-th text-laudry-gray-200 leading-6.5 ";

export const STYLE_HEADING_3_BOLD_24_18 =
  "  font-bold text-lg  md:text-2xl text-laudry-gray-200 leading-6.5";
export const STYLE_HEADING_3_BOLD_24_18_TH =
  "  font-bold text-lg  md:text-2xl text-laudry-gray-200 leading-6.5";

export const STYLE_HEADING_4_20 =
  "font-semibold text-xl md:text-22 text-laundry-gray-200 leading-8";

export const STYLE_HEADING_4_20_TH =
  "font-semibold text-xl-th md:text-22-th text-laundry-gray-200 leading-8";

export const STYLE_BODY_1_TEXT_LG =
  " font-bold text-laundry-gray-100 text-lg leading-6 ";

export const STYLE_BODY_1_TEXT_LG_TH =
  " font-bold text-laundry-gray-100 text-lg-th leading-6 ";

export const STYLE_BODY_1_SEMIBOLD_SM = (language) => {
  if (language === "TH") {
    return "font-semibold text-laundry-gray-100 text-sm-th md:text-lg-th leading-6 ";
  } else {
    return "font-semibold text-laundry-gray-100 text-sm md:text-lg leading-6 ";
  }
};
export const STYLE_BODY_1_SEMIBOLD = "font-semibold  text-lg leading-6";
export const STYLE_BODY_1_SEMIBOLD_TH = "font-semibold  text-lg-th leading-6";

export const STYLE_BODY_2_SEMIBOLD = "font-semibold  text-base leading-6";
export const STYLE_BODY_2_SEMIBOLD_TH = "font-semibold  text-base leading-6";

export const STYLE_BODY_2_SEMIBOLD_SM =
  "font-semibold  text-sm md:text-base leading-6";

export const STYLE_BODY_2_SEMIBOLD_SM_TH =
  "font-semibold  text-sm-th md:text-base leading-6";

export const STYLE_BODY_2_REGULAR = (language) => {
  if (language === "TH") {
    return " text-sm-th md:text-base-th text-laundry-gray-100 leading-6 font-normal ";
  } else {
    return " text-sm md:text-base text-laundry-gray-100 leading-6 font-normal ";
  }
};

export const STYLE_BODY_2_REGULAR_TEXT_BASE = (language) => {
  if (language === "TH") {
    return " text-sm-th md:text-base-th text-laundry-gray-100 leading-6 ";
  } else {
    return " text-sm md:text-base text-laundry-gray-100 leading-6 ";
  }
};
export const STYLE_BODY_2_REGULAR_XS = (language) => {
  if (language === "TH") {
    return "text-laundry-gray-100 leading-5 md:leading-6 text-xs-th md:text-base-th text-center";
  } else {
    return "text-laundry-gray-100 leading-5 md:leading-6 text-xs md:text-base text-center";
  }
};

// export const STYLE_BODY_2_REGULAR_XS_TH =
//   "text-laundry-gray-100 leading-5 md:leading-6 text-xs-th md:text-base-th text-center";

export const STYLE_BODY_2_REGULAR_XS_BASE = (language) => {
  if (language === "TH") {
    return "text-laundry-gray-100 leading-5 md:leading-6 text-xs-th md:text-base-th text-center";
  } else {
    return "text-laundry-gray-100 leading-5 md:leading-6 text-xs md:text-base text-center";
  }
};

export const STYLE_BODY_2_REGULAR_XS_BASE_NO_COLOUR = (language) => {
  if (language === "TH") {
    return " leading-5 md:leading-6 text-xs-th md:text-base-th ";
  } else {
    return " leading-5 md:leading-6 text-xs md:text-base ";
  }
};

// return ;
// if (language === "TH") {
//   return "leading-5 md:leading-6 text-sm md:text-lg";
// } else {
//   return "leading-5 md:leading-6 text-xs md:text-base";
// }

export const STYLE_BODY_3_REGULAR = (e) => {
  return STYLE_BODY_2_REGULAR(e);
};
export const STYLE_BODY_3_REGULAR_TEXT_SM = (language) => {
  if (language === "TH") {
    return " text-sm-th leading-6 ";
  } else {
    return " text-sm leading-6 ";
  }
};

export const STYLE_BODY_2_REGULAR_80 = (language) => {
  if (language === "TH") {
    return " font-normal text-sm-th md:text-base-th leading-6 text-laundry-gray-80";
  } else {
    return " font-normal text-sm md:text-base leading-6 text-laundry-gray-80";
  }
};

export const STYLE_BODY_4_REGULAR = (language) => {
  if (language === "TH") {
    return " text-xs-th leading-5 text-laundry-gray-100 ";
  } else {
    return " text-xs leading-5 text-laundry-gray-100 ";
  }
};

//HOVER
export const STYLE_HOVER_BLUE =
  "hover:text-laundry-primary-blue cursor-pointer group";

//FONT-SIZE
export const STYLE_SIZE_FAQ = (language) => {
  if (language === "TH") {
    return " text-lg-th md:text-28-th leading-8.6 ";
  } else {
    return " text-lg md:text-28 leading-8.6 ";
  }
};
export const STYLE_SIZE_FAQ_HOME = (language) => {
  if (language === "TH") {
    return " text-xl-th md:text-2xl-th leading-6 md:leading-6.5 ";
  } else {
    return " text-xl md:text-2xl leading-6 md:leading-6.5 ";
  }
};
export const STYLE_BOLD_BLUE = " text-laundry-primary-blue font-bold";

//PARENT
export const STYLE_FLEX = "flex items-center gap-1 my-2";
export const STYLE_FLEX_ITEMS_START = "flex gap-2 items-start";
export const STYLE_JUSTIFY_BETWEEN = "flex justify-between my-2 md:my-4 ";
export const STYLE_BANNER_BLUE =
  " w-full h-banner_mb md:h-banner_blue md:pt-13 2xl:pt-10   ";
export const STYLE_WRAPPER_MIDDLE =
  "bg-white rounded-xl pb-2 px-4 md:px-6 md:pb-6 pt-2  ordershadow";
export const STYLE_WRAPPER_CARD = "bg-white rounded-xl px-4 md:p-6 ordershadow";
export const STYLE_WRAPPER_MIDDLE_PROGRAM_BACK =
  "bg-white md:rounded-t-xl md:rounded-xl  md:rounded-b-none px-4 md:px-6";
export const STYLE_PADDING_WINDOWS = " px-4 md:px-10 xl:px-37 mx-auto";
export const STYLE_PADDING_READING =
  " px-4 md:px-10 xl:px-padding_read  mx-auto";

export const STYLE_PADDING_NO_MB = "md:px-10 xl:px-padding_read mx-auto";
export const STYLE_PADDING_PROGRAM = "px-3.5 md:px-10 xl:px-37  mx-auto";
export const STYLE_BG_BASKET =
  "bg-white rounded-t-xl md:rounded-xl md:rounded-t-none ordershadow ";
export const STYLE_PADDING_WHITE_BASKET = "bg-white px-4 md:pt-6 pb-4 md:px-6 ";
export const STYLE_PROGRAM_BACK = (language) => {
  if (language === "TH") {
    return "  items-center text-center text-laudry-gray-200 text-xl-th md:text-28-th leading-6 md:leading-8 font-bold h-16 md:h-20 mb-[10px] md:mb-0  relative ";
  } else {
    return "  items-center text-center text-laudry-gray-200 text-xl md:text-28 leading-6 md:leading-8 font-bold h-16 md:h-20 mb-[10px] md:mb-0  relative ";
  }
};
export const STYLE_MIN_H_FULL =
  "flex flex-col justify-between min-h-screen +  md:min-h-full overflow-x-hidden <6> ";

export const STYLE_SPACE_Y = "space-y-2 md:space-y-4";
export const STYLE_CONTAINER =
  "text-gray-700 bg-white md:bg-laundry-borderbottomline relative  h-full  md:pb-11 pt-16 md:pt-[116px] lg:pt-[116px] ";
export const STYLE_CONTAINER_NO_PADDING_READ =
  "text-gray-700 bg-laundry-bglight md:bg-laundry-borderbottomline relative  h-full  md:pb-11 pt-16 md:pt-[116px] lg:pt-[116px] ";
export const STYLE_MARGIN_TOP = "mt-16 md:mt-[72px] relative";

// export const STYLE_LINK_BLUE =
//   "linkblue text-laundry-primary-blue underline underline-offset-2 mx-1 md:hover:font-bold cursor-pointer ";

export const STYLE_LINK_BLUE = "linkblue  mx-1 cursor-pointer  ";
export const STYLE_LINK_BLUE_NO_MX =
  "linkblue cursor-pointer whitespace-nowrap ";
export const STYLE_MARGIN_READ = " md:mx-10 xl:mx-padding_read";
export const STYLE_MARGIN_WINDOW = " md:mx-10 xl:mx-37";
export const STYLE_MARGIN_WINDOW_LEFT = " md:mx-10 xl:ml-37";
export const STYLE_MARGIN_WINDOW_RIGHT = " md:mx-10 xl:mr-37";
export const STYLE_MARGIN_READ_LEFT = " md:ml-10 xl:ml-padding_read";
export const STYLE_MARGIN_READ_RIGHT = " md:mr-10 xl:mr-padding_read";
export const STYLE_MAX_WIDTH_DESKTOP = "max-w-desktop mx-auto";
export const STYLE_TH_PROGRAMBACK_COLSPAN =
  "col-span-2 text-left md:col-span-1 md:text-center";

//MODAL
export const STYLE_PARENT_MODAL =
  "flex justify-between items-center px-5 h-login_button md:h-select_language md:w-modals_select cursor-pointer  mx-auto";
export const STYLE_PARENT_MODAL_WIDTH = " w-modalsmobile md:w-modals";
export const STYLE_LANGUAGE = (language) => {
  // if (language === "TH") {
  // return " text-base-th md:text-lg-th  leading-6 cursor-pointer flex gap-3 md:gap-4 items-center";
  // } else {
  return " text-base md:text-lg leading-6  cursor-pointer flex gap-3 md:gap-4 items-center ";
  // }
};

export const STYLE_BG_OPACITY_MODAL = "bg-opacity-20 z-30";
export const STYLE_BG_TRANSPARENT_MODAL = "bg-opacity-0 z-0 w-0 h-0";
export const STYLE_BG_MODAL = "bg-black fixed inset-0  ";
export const STYLE_PARENT_PANEL_MODAL =
  " px-4 pt-4 md:px-6 md:pt-6  w-modals_mb_logout md:w-modals font-Poppins  ";
export const STYLE_UNSELECT_LANGUAGE =
  "border border-landry-gray-stroke rounded-lg text-laundry-gray-50";
export const STYLE_PREPARE_LANGUAGE =
  " border border-laundry-primary-blue bg-landry-blue-selcted rounded-lg text-laundry-gray-100  ";
export const STYLE_BUTTON_CANCEL_MODAL =
  " mx-auto  h-h_50 w-full md:h-input md:w-modals_button rounded-lg bg-white  border border-laundry-primary-blue text-laundry-primary-blue md:hover:text-laundry-gray-80 md:hover:border-laundry-gray-80 text-center font-semibold duration-0  focus:outline-none";
export const STYLE_BUTTON_BLUE_MODAL =
  " mx-auto h-h_50 w-modals_mb_button md:h-input md:w-modals_button bg-laundry-primary-blue  rounded-lg text-white font-semibold shadow-md shadow-laundry-shadowblue md:hover:bg-laundry-gray-80 md:hover:order-blue duration-0 text-sm xl:text-base focus:outline-none text-center ";
export const STYLE_BUTTON_CANCEL_MODAL_LANGUAGE = (language) => {
  if (language === "TH") {
    return " h-h_50 w-full md:h-input md:w-modals_button rounded-lg bg-white  border border-laundry-primary-blue text-laundry-primary-blue md:hover:text-laundry-gray-80 md:hover:border-laundry-gray-80 text-center font-semibold duration-0 text-sm-th xl:text-base-th focus:outline-none ";
  } else {
    return " h-h_50 w-full md:h-input md:w-modals_button rounded-lg bg-white  border border-laundry-primary-blue text-laundry-primary-blue md:hover:text-laundry-gray-80 md:hover:border-laundry-gray-80 text-center font-semibold duration-0 text-sm xl:text-base focus:outline-none ";
  }
};
export const STYLE_BUTTON_BLUE_MODAL_LANGUAGE = (language) => {
  if (language === "TH") {
    return "h-h_50 w-full md:h-input md:w-modals_button bg-laundry-primary-blue  rounded-lg text-white font-semibold shadow-md shadow-laundry-shadowblue md:hover:bg-laundry-gray-80 md:hover:order-blue duration-0 text-sm-th xl:text-base-th focus:outline-none text-center ";
  } else {
    return "h-h_50 w-full md:h-input md:w-modals_button bg-laundry-primary-blue  rounded-lg text-white font-semibold shadow-md shadow-laundry-shadowblue md:hover:bg-laundry-gray-80 md:hover:order-blue duration-0 text-sm xl:text-base focus:outline-none text-center ";
  }
};
export const STYLE_BUTTON_OUTLINE =
  "rounded-lg bg-white  border border-laundry-primary-blue text-laundry-primary-blue md:hover:text-laundry-gray-80 md:hover:border-laundry-gray-80 text-center font-semibold duration-0 text-sm xl:text-base focus:outline-none";
export const STYLE_BUTTON_BLUE_WFULL =
  "bg-laundry-primary-blue  rounded-lg text-white font-semibold shadow-md shadow-laundry-shadowblue md:hover:bg-laundry-gray-80 md:hover:order-blue duration-0 text-sm xl:text-base focus:outline-none text-center";

//ICON
export const STYLE_ICON_CURSOR = " w-5 md:w-4 cursor-pointer";
export const STYLE_ICON_INFO = " w-4 md:w-5 cursor-pointer";
export const STYLE_ICON_SAMEDAY = "w-6 h-6 cursor-pointer ";
export const STYLE_LINE_IOCN_FLOAT =
  "bg-laundry-linebg_button w-border_blue h-input rounded-full p-[11px] cursor-pointer md:hover:bg-green-400 duration-100";
export const STYLE_ARROW_RED =
  "group-hover:text-laundry-primary-blue text-[#DC251C]";

//TITLE
export const STYLE_HEAD_TITLE = (language) => {
  if (language === "TH") {
    return "text-laudry-gray-200  text-28-th md:text-4xl-th text-center font-bold";
  } else {
    return "text-laudry-gray-200  text-28 md:text-4xl text-center font-bold";
  }
};

export const STYLE_SUB_TITLE = (language) => {
  if (language === "TH") {
    return " text-sm-th md:text-base-th text-laundry-gray-100 font-semibold ";
  } else {
    return " text-sm md:text-base text-laundry-gray-100 font-semibold ";
  }
};

export const STYLE_SUB_TITLE_UNDERLINE = (language) => {
  if (language === "TH") {
    return " text-sm-th md:text-base-th text-laundry-gray-100 font-semibold underline";
  } else {
    return " text-sm md:text-base text-laundry-gray-100 font-semibold underline ";
  }
};

export const STYLE_SUB_DETAIL = (language) => {
  if (language === "TH") {
    return " text-13-th md:text-sm-th text-laundry-gray-80 font-normal ";
  } else {
    return " text-13 md:text-sm text-laundry-gray-80 font-normal ";
  }
};

export const STYLE_TEXT_DETAIL = (language) => {
  if (language === "TH") {
    return " text-sm-th text-laundry-gray-100 mt-[6px] md:mt-4 ";
  } else {
    return " text-sm text-laundry-gray-100 mt-[6px] md:mt-4 ";
  }
};
export const STYLE_SUB_TEXT_DETAIL = (language) => {
  if (language === "TH") {
    return " text-10-th md:text-xs-th text-laundry-gray-100 font-normal ";
  } else {
    return " text-10 md:text-xs text-laundry-gray-100 font-normal ";
  }
};
export const STYLE_SUB_TEXT_DETAIL_LIGHTGRAY = (language) => {
  if (language === "TH") {
    return "text-xs-th text-laundry-gray-80 font-normal";
  } else {
    return "text-xs text-laundry-gray-80 font-normal";
  }
};

export const STYLE_TITLE_SEMIBOLD = (language) => {
  if (language === "TH") {
    return " text-base-th md:text-lg-th text-laudry-gray-200 font-semibold ";
  } else {
    return " text-base md:text-lg text-laudry-gray-200 font-semibold ";
  }
};
export const STYLE_TITLE_SEMIBOLD_ORDER_SPACIAL = (language) => {
  if (language === "TH") {
    return " text-base-th md:text-lg-th text-laudry-gray-200 font-semibold ";
  } else {
    return " text-base md:text-lg text-laudry-gray-200 font-semibold -mt-0.5 ";
  }
};
export const STYLE_TITLE_BOLD = (language) => {
  if (language === "TH") {
    return " text-base-th md:text-lg-th text-laudry-gray-200 font-bold ";
  } else {
    return " text-base md:text-lg text-laudry-gray-200 font-bold ";
  }
};

export const STYLE_SUBTITLE_SEMIBOLD = (language) => {
  if (language === "TH") {
    return "text-laudry-gray-200 font-semibold leading-6 text-sm-th md:text-base-th break-all ";
  } else {
    return "text-laudry-gray-200 font-semibold leading-6 text-sm md:text-base break-all ";
  }
};

export const STYLE_SUBTITLE_SEMIBOLD_ADD_ADDRESS = (language) => {
  if (language === "TH") {
    return "text-laudry-gray-200 font-semibold leading-8 text-sm-th md:text-base-th break-all ";
  } else {
    return "text-laudry-gray-200 font-semibold leading-7 text-sm md:text-base break-all ";
  }
};

export const STYLE_SUBTITLE_BOLD = " text-laudry-gray-200 font-bold ";

export const STYLE_SEMIBOLD_BLUE =
  "text-laundry-primary-blue md:hover:text-laundry-mywash duration-0 font-semibold";

export const STYLE_SEMIBOLD_RED =
  "text-laundry-red-100 md:hover:text-red-600 duration-0 font-semibold";

export const STYLE_DETAIl_SIZE_PRICE = (language) => {
  if (language === "TH") {
    return "text-base-th text-center text-laundry-gray-100 font-semibold mt-4";
  } else {
    return "text-base text-center text-laundry-gray-100 font-semibold mt-4";
  }
};

export const STYLE_HEAD_MEDIUM = (language) => {
  if (language === "TH") {
    return "text-laundry-gray-200 text-base-th md:text-lg-th font-medium leading-6";
  } else {
    return "text-laundry-gray-200 text-base md:text-lg font-medium leading-6";
  }
};
export const STYLE_BLUE_SEMIBOLD =
  "text-laundry-primary-blue font-semibold cursor-pointer";
export const STYLE_TITLE_MEDIUM = " text-laudry-gray-200 font-medium";

export const STYLE_TEXT_SIZE_SMALL = (language) => {
  if (language === "TH") {
    return " text-xs-th md:text-sm-th ";
  } else {
    return " text-xs md:text-sm ";
  }
};

//LOGIN

export const STYLE_FLAG = " h-6 w-8 rounded-sm ";
export const STYLE_TEXT_OTP = "text-laundry-gray-80 text-lg text-center  ";
export const STYLE_NUMBER_OTP =
  "text-center text-laudry-gray-200 font-semibold text-lg leading-6";

export const STYLE_TEXT_SMS = (language) => {
  if (language === "TH") {
    return " text-sm-th md:text-base-th text-center text-laundry-gray-80 ";
  } else {
    return " text-sm md:text-base text-center text-laundry-gray-80 ";
  }
};

export const STYLE_IMG_CENTER = " h-12 md:h-14 mx-auto";
export const STYLE_SPACE_LIST = " mt-10 my-20 space-y-6 px-4";
export const STYLE_INPUT_PHONENUMBER =
  "bg-white border border-laudry-stroke w-full h-12 rounded-lg flex items-center gap-2 p-2";

export const STYLE_DESCRIPTION_LOGIN_PHONE = (language) => {
  if (language === "TH") {
    return "text-laundry-gray-80 text-center leading-5 md:leading-6 text-xs-th md:text-sm-th";
  } else {
    return "text-laundry-gray-80 text-center leading-5 md:leading-6 text-xs md:text-sm";
  }
};

//PROFILE
export const STYLE_BG_INPUT_DISABLE_PHONENUMBER = (language) => {
  if (language === "TH") {
    return "bg-[#F5F6F9] text-gray-500 flex items-center gap-3 w-full rounded-lg h-[56px] md:h-[58px] border border-[#D9DBE9] text-base-th pr-[14px]";
  } else {
    return "bg-[#F5F6F9] text-gray-500 flex items-center gap-3 w-full rounded-lg h-[56px] md:h-[58px] border border-[#D9DBE9] text-base pr-[14px]";
  }
};
export const STYLE_BORDER_RIGHT_INPUT_PHONENUMBER =
  "border-r border-r-laudry-stroke h-full mr-10";

export const STYLE_BOTTOM_MIN_H_FULL_PROFILE =
  "w-full md:py-5 pb-20 md:pb-5 space-y-6 md:space-y-0";

export const STYLE_PARENT_PROFILE =
  "-mb-4 md:mb-0  space-y-3 md:space-y-6 pt-2.5 md:pt-0";

export const STYLE_TEXT_EMPTY_PROFILE = (language) => {
  if (language === "TH") {
    return "text-sm-th md:text-base-th text-laundry-gray-80 leading-6 flex justify-center items-center";
  } else {
    return "text-sm md:text-base text-laundry-gray-80 leading-6 flex justify-center items-center";
  }
};

//BUTTON
export const STYLE_BUTTON_BLUE = (language) => {
  if (language === "TH") {
    return "w-full bg-laundry-primary-blue  md:p-3 xl:p-4 rounded-lg text-white font-semibold shadow-md shadow-laundry-shadowblue md:hover:bg-laundry-gray-80 md:hover:order-blue duration-0 text-sm-th xl:text-base-th leading-6 focus:outline-none h-h_50 md:h-input";
  } else {
    return "w-full bg-laundry-primary-blue  md:p-3 xl:p-4 rounded-lg text-white font-semibold shadow-md shadow-laundry-shadowblue md:hover:bg-laundry-gray-80 md:hover:order-blue duration-0 text-sm xl:text-base leading-6 focus:outline-none h-h_50 md:h-input";
  }
};
export const STYLE_BUTTON_BLUE_DISABLED = (language) => {
  if (language === "TH") {
    return "w-full bg-laundry-bglight p-4 md:p-3 xl:p-4 rounded-lg text-laudry-stroke font-semibold text-sm-th xl:text-base-th focus:outline-none cursor-auto h-h_50 md:h-input";
  } else {
    return "w-full bg-laundry-bglight p-4 md:p-3 xl:p-4 rounded-lg text-laudry-stroke font-semibold text-sm xl:text-base focus:outline-none cursor-auto h-h_50 md:h-input";
  }
};

export const STYLE_BORDER_BLUE = (language) => {
  if (language === "TH") {
    return " w-full rounded-lg bg-white p-4 border border-laundry-primary-blue text-laundry-primary-blue md:hover:text-laundry-mywash md:hover:border-laundry-mywash text-center font-semibold duration-0 text-sm-th xl:text-base-th focus:outline-none";
  } else {
    return " w-full rounded-lg bg-white p-4 border border-laundry-primary-blue text-laundry-primary-blue md:hover:text-laundry-mywash md:hover:border-laundry-mywash text-center font-semibold duration-0 text-sm xl:text-base focus:outline-none";
  }
};

export const STYLE_BORDER_BLUE_ADDRESS = (language) => {
  if (language === "TH") {
    return "w-full rounded-lg bg-white p-[14px] md:p-4 border border-laundry-primary-blue md:hover:border-laundry-gray-80 text-laundry-primary-blue md:hover:text-laundry-gray-80   text-center font-semibold duration-0 text-sm-th xl:text-base-th focus:outline-none h-full";
  } else {
    return "w-full rounded-lg bg-white p-[14px] md:p-4 border border-laundry-primary-blue md:hover:border-laundry-gray-80 text-laundry-primary-blue md:hover:text-laundry-gray-80   text-center font-semibold duration-0 text-sm xl:text-base focus:outline-none h-full";
  }
};

export const STYLE_BUTTON_ICON_LEFT =
  " w-34 h-34 md:w-10 md:h-10 bg-white  border border-laundry-primary-blue p-1.4 md:p-2 text-laundry-primary-blue md:hover:text-laundry-gray-80 md:hover:border-laundry-gray-80 rounded-full duration-0 cursor-pointer";
export const STYLE_INPUT_OPT =
  " w-w_47 h-h_66  md:w-w_52  mr-3 border-none rounded-lg bg-white focus:outline-none ring-1 ring-laudry-stroke focus:ring-laundry-primary-blue text-center text-32 leading-8.3 font-medium";
export const STYLE_BORDER_BLUE_BUTTON =
  "rounded-lg bg-white  border border-laundry-primary-blue p-4 text-laundry-primary-blue md:hover:text-laundry-mywash md:hover:border-laundry-mywash text-center font-semibold duration-0 ";
export const STYLE_BUTTON_BLUE_ORDER =
  "rounded-lg bg-laundry-primary-blue   p-4 text-white md:hover:bg-laundry-gray-80 md:hover:order-blue md:hover:text-white  text-center font-semibold ";
export const STYLE_PARENT_TWOBUTTON =
  "grid grid-cols-2 h-[50px] md:h-input gap-4 md:gap-6";
export const STYLE_BOTTOM_MIN_H_FULL = "  pb-14 md:pb-0";
export const STYLE_PARNT_TWOBUTTON_WFULL =
  "grid grid-cols-2 text-center my-4 gap-6 h-input items-center";
export const STYLE_TWOBUTTON_ADDRESS =
  "grid grid-cols-2 text-center mt-4 gap-4 md:gap-6 h-[50px] md:h-input justify-center items-center";
export const STYLE_BLUE_BUTTON_WIDHT = "md:w-64 md:mx-auto  mt-9";

export const STYLE_BUTTON_MYWASH = (language) => {
  if (language === "TH") {
    return "w-full bg-laundry-mywash md:hover:bg-laundry-primary-blue p-4 md:p-3 xl:p-4 rounded-lg text-white font-semibold shadow-md shadow-laundry-shadowblue text-base-th focus:outline-none h-input";
  } else {
    return "w-full bg-laundry-mywash md:hover:bg-laundry-primary-blue p-4 md:p-3 xl:p-4 rounded-lg text-white font-semibold shadow-md shadow-laundry-shadowblue text-base focus:outline-none h-input";
  }
};
export const STYLE_BUTTON_MYSHOES = (language) => {
  if (language === "TH") {
    return "w-full bg-laundry-myshoes md:hover:bg-laundry-hovermyshoes p-4 md:p-3 xl:p-4 rounded-lg text-white font-semibold shadow-md shadow-laundry-shadowpink  text-base-th focus:outline-none h-input";
  } else {
    return "w-full bg-laundry-myshoes md:hover:bg-laundry-hovermyshoes p-4 md:p-3 xl:p-4 rounded-lg text-white font-semibold shadow-md shadow-laundry-shadowpink  text-base focus:outline-none h-input";
  }
};
export const STYLE_BUTTON_MYIRON = (language) => {
  if (language === "TH") {
    return "w-full bg-laundry-myiron md:hover:bg-laundry-hovermyiron p-4 md:p-3 xl:p-4 rounded-lg text-white font-semibold shadow-md shadow-laundry-shadowgreen  text-base-th focus:outline-none h-input";
  } else {
    return "w-full bg-laundry-myiron md:hover:bg-laundry-hovermyiron p-4 md:p-3 xl:p-4 rounded-lg text-white font-semibold shadow-md shadow-laundry-shadowgreen  text-base focus:outline-none h-input";
  }
};

//BAR
export const STYLE_BUTTON_BAR_DISABLE = (language) => {
  if (language === "TH") {
    return "w-full bg-laundry-bglight p-4 md:p-2 rounded-lg text-laudry-stroke font-semibold text-sm xl:text-base focus:outline-none cursor-auto h-input";
  } else {
    return "w-full bg-laundry-bglight p-4 md:p-2 rounded-lg text-laudry-stroke font-semibold text-sm xl:text-base focus:outline-none cursor-auto h-input";
  }
};

export const STYLE_BUTTON_BAR_BLUE = (language) => {
  if (language === "TH") {
    return "w-full bg-laundry-primary-blue p-4 md:py-2 md:px-6 rounded-lg text-white font-semibold shadow-md shadow-laundry-shadowblue  md:hover:bg-laundry-gray-80 md:hover:order-blue md:hover:text-white duration-0 text-sm-th xl:text-base-th focus:outline-none h-h_50 md:h-input";
  } else {
    return "w-full bg-laundry-primary-blue p-4 md:py-2 md:px-6 rounded-lg text-white font-semibold shadow-md shadow-laundry-shadowblue  md:hover:bg-laundry-gray-80 md:hover:order-blue md:hover:text-white duration-0 text-sm xl:text-base focus:outline-none h-h_50 md:h-input";
  }
};

export const STYLE_TOTAL_BAR_TEXT = (language) => {
  if (language === "TH") {
    return "flex justify-between  text-base-th md:text-2xl-th mb-4 mt-2 leading-6 text-laudry-gray-200 font-semibold";
  } else {
    return "flex justify-between  text-base md:text-2xl mb-4 mt-2 leading-6 text-laudry-gray-200 font-semibold";
  }
};

export const STYLE_HEIGHT_BAR = "h-[106px] md:h-[124px]";

//TAB
export const STYLE_ACTIVE_TAB =
  "bg-white rounded-lg  shadow-md shadow-laundry-shadowbg font-semibold text-laundry-primary-blue h-10 md:h-12 flex justify-center items-center";
export const STYLE_INACTIVE_TAB =
  "cursor-pointer fot-medium text-laundry-gray-50";
export const STYLE_TAB_PARENT = " text-center m-auto w-full p-2    ";

//NAVBAR
export const STYLE_BG_NAVBAR =
  " bg-white w-full h-navbar_desktop fixed z-50 flex flex-col justify-center items-center";
export const STYLE_FLEX_NAVBAR_DESKTOP =
  " flex items-center  justify-between md:gap-[48px] lg:gap-[95px] xl:gap-[112px] ";
export const STYLE_NAVBAR_MOBILE =
  "bg-white w-full h-16 flex justify-between items-center  py-[10px] gap-6   px-[6px] ";
export const STYLE_NAVBAR_LOGO =
  " h-h_25 w-logo_navbar_mobile xl:h-9 xl:w-logo_navbar_desktop mx-auto cursor-pointer";

export const STYLE_LOCATION_NAVBAR = (language) => {
  if (language === "TH") {
    return "flex items-center text-laudry-gray-200 font-medium  text-sm-th xl:text-base-th md:w-full xl:w-location_search border border-laudry-stroke rounded-[10px] h-10 px-2 ";
  } else {
    return "flex items-center text-laudry-gray-200 font-medium  text-sm xl:text-base md:w-full xl:w-location_search border border-laudry-stroke rounded-[10px] h-10 px-2 ";
  }
};

export const STYLE_LOCATION_NAVBAR_PLACEHOLDER = (language) => {
  if (language === "TH") {
    return " w-full md:w-24 lg:w-40 xl:w-full pl-[2px] focus:outline-none border-none font-medium placeholder:text-laundry-gray-50 font-Poppins text-sm-th lg:text-base-th";
  } else {
    return " w-full md:w-24 lg:w-40 xl:w-full pl-[2px] focus:outline-none border-none font-medium placeholder:text-laundry-gray-50 font-Poppins text-sm lg:text-base";
  }
};

export const STYLE_LOCATION_NAVBAR_PLACEHOLDER_LOCATION = (language) => {
  if (language === "TH") {
    return " w-full  pl-[2px] focus:outline-none border-none font-medium font-Poppins text-sm-th lg:text-base-th";
  } else {
    return " w-full  pl-[2px] focus:outline-none border-none font-medium font-Poppins text-sm lg:text-base";
  }
};
export const STYLE_FLEX_MENU_NAVBAR =
  " flex items-center lg:gap-2 xl:gap-0 justify-end  w-icon_and_button_navbar_mb md:w-[234px] lg:w-[317px] xl:w-icon_and_button_navbar h-11 ";
export const STYLE_IMG_LANGUAGE =
  "  w-[54px] md:w-head_language h-h_30 cursor-pointer  md:mx-auto ";
export const STYLE_ICON_FLAQ_MODUAL =
  " w-8 md:w-[40px] md:h-[30px] cursor-pointer mx-auto";
export const STYLE_ICON_FLAQ_DRAWER = " w-6 h-6 cursor-pointer ";
export const STYLE_ICON_NAVBAR =
  " text-laundry-gray-100 w-5 xl:w-4 cursor-pointer";
export const STYLE_ICON_LOGIN_OUT_NAVBAR_MB =
  " text-laundry-gray-100 w-w_16_98 h-h_18_5 mx-3 cursor-pointer ";
export const STYLE_VIEWBOX_ICON = "w-12 h-12 flex justify-center items-center";

//DRAWER
export const STYLE_PARENT_MENU =
  " flex gap-2 items-center  md:hover:text-laundry-primary-blue";

export const STYLE_TITLE_MENU = (language) => {
  if (language === "TH") {
    return " text-sm-th md:text-base-th text-laundry-gray-100 md:hover:text-[#3AB4ED] cursor-pointer";
  } else {
    return " text-sm md:text-base text-laundry-gray-100 md:hover:text-[#3AB4ED] cursor-pointer";
  }
};

export const STYLE_BORDER_BOTTOM_MENU =
  "border-b border-b-laundry-primary-blue-30 w-full col-span-full my-3 md:my-4";

export const STYLE_ICON_DRAWER = "w-6 h-6 cursor-pointer text-[#3AB4ED]";

//DRAWER INFO
export const STYLE_IMG_DRAWER_INFO =
  " w-img_modals_mb md:w-img_modals absolute top-[25px] md:top-[19px]  left-1/2 transform -translate-x-1/2 ";

export const STYLE_BG_WHITE_DRAWER_INFO =
  " bg-white rounded-t-2xl text-white text-center absolute bottom-0  ";

export const STYLE_TEXT_DES_DRAWER_INFO = (language) => {
  if (language === "TH") {
    return " text-laundry-gray-80 text-center text-xs-th xl:text-sm-th  md:mb-0 px-4 md:px-10 xl:px-[263px] font-normal ";
  } else {
    return " text-laundry-gray-80 text-center text-xs xl:text-sm  md:mb-0 px-4 md:px-10 xl:px-[263px] font-normal ";
  }
};
export const STYLE_BG_BLUE_DRAWER_INFO =
  " w-screen h-head_blue_mb md:h-head_blue rounded-t-2xl ";

export const STYLE_SPACE_BUTTON_BLUE_DRAWER_INFO =
  " px-4  md:py-0 md:px-10 xl:px-padding_read  ";

export const STYLE_SPACE_BUTTON_BLUE_DRAWER_INFO_MB = " py-4";

export const STYLE_LINE_MB =
  " w-10 md:w-0 h-1 md:h-0 bg-laundry-primary-blue-50  rounded-full absolute top-[10px] m-auto left-0 right-0";

//FOOTER
export const STYLE_HOVER_WHITE = " hoverwhite  w-fit mx-auto md:mx-0";

export const STYLE_TEXT_GRAY_80_UNDERLINE_FOOTER = (language) => {
  if (language === "TH") {
    return "cursor-pointer text-xs-th md:text-sm-th hovergray";
  } else {
    return "cursor-pointer text-xs md:text-sm hovergray";
  }
};

export const STYLE_TEXT_GRAY_80 = (language) => {
  if (language === "TH") {
    return " text-laundry-gray-80 text-xs-th md:text-sm-th ";
  } else {
    return " text-laundry-gray-80 text-xs md:text-sm";
  }
};

export const STYLE_TEXT_WHITE_FOOTER = (language) => {
  if (language === "TH") {
    return "text-white space-y-2 md:space-y-2.5 text-sm-th md:text-base-th underline underline-offset-2 leading-6";
  } else {
    return "text-white space-y-2 md:space-y-2.5 text-sm md:text-base underline underline-offset-2 leading-6";
  }
};

export const STYLE_TEXT_WHITE_LOCATION_FOOTER = (language) => {
  if (language === "TH") {
    return "text-white underline underline-offset-2 text-sm-th leading-6 cursor-pointer";
  } else {
    return "text-white underline underline-offset-2 text-sm leading-6 cursor-pointer";
  }
};

export const STYLE_TEXT_WHITE_LOCATION_FOOTER_NO_UNDERLINE = (language) => {
  if (language === "TH") {
    return "  text-[18px] leading-6 text-[#6E7191] ";
  } else {
    return "  text-[16px] leading-6 text-[#6E7191] ";
  }
};

export const STYLE_INPUT_FOOTER =
  " w-full h-8 focus:outline-none border-none  placeholder-laundry-gray-50  bg-transparent appearance-none ";

export const STYLE_BG_INPUT_FOOTER =
  "bg-white border border-laudry-stroke h-h_50 rounded-lg flex items-center gap-2 ";

export const STLYE_INPUT_LOGIN_PHONE = "bg-white h-14 flex items-center ";

export const STYLE_FLEX_INPUT_FOOTER = "flex items-center gap-3 h-full px-4 ";

export const STYLE_LOGO_FOOTER =
  " mx-auto md:mx-0 h-10 md:h-auto xl:h-14 mb-2 xl:mb-6 cursor-pointer my-auto";

export const STYLE_ICON_SOCIAL =
  " w-7 md:w-head_language text-white md:hover:text-laundry-primary-blue cursor-pointer duration-0";
export const STYLE_ICON_SOCAIL_FOOTER =
  "w-6 md:w-head_language text-white md:hover:text-laundry-primary-blue cursor-pointer duration-0";
export const STYLE_MENU_FOOTER =
  " grid text-center md:flex md:gap-[37px] lg:gap-17  md:text-left mt-4 md:mt-0 ";

export const STYLE_TEXT_LOGO_FOOTER = (language) => {
  if (language === "TH") {
    return " flex justify-center md:justify-start items-center gap-3 md:gap-2 lg:gap-4 text-sm-th xl:text-base-th text-white font-semibold";
  } else {
    return " flex justify-center md:justify-start items-center gap-3 md:gap-2 lg:gap-4 text-sm xl:text-base text-white font-semibold";
  }
};

export const STYLE_BG_BLACK_FOOTER = " w-full bg-black h-full py-6.5 md:py-10 ";

export const STYLE_GRID_FOOTER = " grid grid-cols-1 md:grid-cols-4  ";

export const STYLE_BORDER_FOOTER =
  "border-b border-laundry-gray-80 w-3/4 mx-auto md:w-full my-4 md:my-5";

export const STYLE_IMG_FOOTER = " h-9 md:h-8 lg:h-9  xl:ml-[112px]";

export const STYLE_CLIENT_WITH_LOGO_FOOTER =
  " md:grid grid-cols-3 md:items-start gap-6 md:gap-5 xl:gap-10 space-y-4 md:space-y-0";

export const STYLE_BG_WHITE_GOOGLE_MAP =
  "bg-white md:bg-laundry-borderbottomline md:-mt-13.5";

export const STYLE_TEXT_REDUCE_REUSE_RECYCLE = (language) => {
  if (language === "TH") {
    return "text-white font-semibold text-xs-th md:text-xs-th lg:text-sm-th leading-6";
  } else {
    return "text-white font-semibold text-xs md:text-xs lg:text-sm leading-6";
  }
};

export const STYLE_PARENT_REDUCE_REUSE_RECYCLE =
  "flex gap-3 md:gap-2 lg:gap-3 items-center justify-center md:justify-start";

export const STYLE_TEXT_HEAD_GOOGLEMAP = (language) => {
  if (language === "TH") {
    return "font-bold text-2xl-th text-laudry-gray-200 leading-6.5";
  } else {
    return "font-bold text-2xl text-laudry-gray-200 leading-6.5";
  }
};

//HOME
export const STYLE_ICON_INFO_HOME =
  " w-[20px] md:w-7 cursor-pointer text-laundry-gray-100 md:text-laudry-gray-200";
export const STYLE_IOCN_INFO_TAB =
  "w-4.5 md:w-7 cursor-pointer text-laundry-gray-100 md:text-laudry-gray-200";
export const STYLE_ICON_INFO_INPROGRAM = " w-4 cursor-pointer my-auto ";
export const STYLE_BANNER =
  " h-40 md:h-banner w-full rounded-2xl md:rounded-none lg:h-[460px]  ";
export const STYLE_PROGRAM_GRID =
  "  block  md:grid md:grid-rows-3 gap-3.5 lg:gap-6 md:grid-flow-col h-program_home_mb md:h-[200px] lg:h-program_home ";
export const STYLE_SELECT_PROGRAM_TITLE =
  " flex items-center justify-center gap-1 ";
export const STYLE_PROGRAM_HOME =
  " flex gap-3 md:grid grid-cols-1  p-[14px] gap-3 md:gap-0 xl:p-0 rounded-2xl text-laundry-gray-100 text-center  cursor-pointer h-full ";
export const STYLE_PROGRAM_HOME_MYWASH =
  " flex gap-3 md:gap-0 md:grid grid-cols-1 p-[14px] xl:py-4 xl:px-3.5  rounded-2xl text-laundry-gray-100 text-left md:text-center  cursor-pointer h-full  bg-laundry-mywash md:hover:bg-laundry-primary-blue md:hover:text-laundry-gray-200   shadow-lg shadow-laundry-shadowblue md:row-span-3 w-full md:w-[344px] lg:w-[513px]  xl:w-program_home_mywash width_program ";
export const STYLE_PROGRAM_HOME_MYWASH_SELECT =
  "flex gap-3 md:grid grid-cols-1  p-[14px]  xl:py-4 xl:px-3.5 rounded-2xl text-laundry-gray-100 text-left md:text-center w-full cursor-pointer h-full  bg-laundry-mywash md:hover:bg-laundry-primary-blue md:hover:text-laundry-gray-200   shadow-lg shadow-laundry-shadowblue md:row-span-3 w-full md:w-[345px] lg:w-[474px]  xl:w-program_home_mywash_select width_program ";
export const STYLE_PROGRAM_DISABLE =
  "flex gap-3 md:grid grid-cols-1  p-[14px]  xl:py-4 xl:px-3.5 rounded-2xl text-laundry-gray-100 text-left md:text-center w-full  h-full  bg-laundry-gray-30 text-laundry-gray-50 shadow-lg  md:row-span-3 w-full md:w-[345px] lg:w-[474px]  xl:w-program_home_mywash_select width_program";
export const STYLE_PROGRAM_HOME_MYIRON =
  "  flex gap-3 md:justify-center items-center  md:gap-6 p-[14px] text-left md:py-4 md:px-3.5 2xl:px-[54px] rounded-2xl text-laundry-gray-100  cursor-pointer bg-laundry-myiron md:hover:bg-laundry-hovermyiron shadow-lg shadow-laundry-shadowgreen w-full md:w-[330px] lg:w-[407px] xl:w-program_home width_program_iron  justify-self-start md:h-20 lg:h-h_120 md:-mt-5 lg:-mt-[26px] ";
export const STYLE_PROGRAM_HOME_MYIRON_SELECT =
  "  flex gap-3 md:justify-center items-center  md:gap-6 p-[14px] text-left xl:py-4 xl:px-3.5 2xl:px-[54px] rounded-2xl text-laundry-gray-100  cursor-pointer bg-laundry-myiron md:hover:bg-laundry-hovermyiron shadow-lg shadow-laundry-shadowgreen w-full md:w-[280px] lg:w-[398px] xl:w-program_home width_program_iron   justify-self-start md:h-20 lg:h-h_120 md:-mt-5 lg:-mt-6";

export const STYLE_PROGRAM_MYIRON_DISABLE =
  " flex gap-3 md:justify-center items-center  md:gap-6 p-[14px] text-left md:py-4 md:px-3.5 2xl:px-[54px] rounded-2xl text-laundry-gray-100  bg-laundry-gray-30 text-laundry-gray-50 cursor-pointer  shadow-lg shadow-laundry-shadowgreen w-full md:w-[330px] lg:w-[407px] xl:w-program_home width_program_iron  justify-self-start md:h-20 lg:h-h_120 md:-mt-5 lg:-mt-[26px";

export const STYLE_PROGRAM_HOME_MYIRON_DISABLE =
  "flex gap-3 md:justify-center items-center  md:gap-6 p-[14px] text-left xl:py-4 xl:px-3.5 2xl:px-[54px] rounded-2xl text-laundry-gray-100   bg-laundry-gray-30 text-laundry-gray-50 shadow-lg  w-full md:w-[330px] lg:w-[407px] xl:w-program_home   justify-self-start md:h-h_120 md:-mt-6";
export const STLE_PROGRAM_HOME_MYSHOES =
  "  flex gap-3 md:justify-center md:gap-6 text-left  p-[14px]  md:py-4 md:px-3.5 2xl:px-[54px] items-center rounded-2xl text-laundry-gray-100  cursor-pointer  bg-laundry-myshoes md:hover:bg-laundry-hovermyshoes shadow-lg shadow-laundry-shadowpink w-full md:w-[330px] lg:w-[407px] xl:w-program_home     row-span-2 h-height_program_home_mb md:h-[111px] lg:h-height_program_home width_program_shoes ";
export const STLE_PROGRAM_HOME_MYSHOES_SELECT =
  "  flex gap-3 md:justify-center md:gap-6 text-left  p-[14px]  xl:py-4 xl:px-3.5 2xl:px-[54px] items-center rounded-2xl text-laundry-gray-100  cursor-pointer  bg-laundry-myshoes md:hover:bg-laundry-hovermyshoes shadow-lg shadow-laundry-shadowpink w-full md:w-[280px] lg:w-[398px] xl:w-program_home row-span-2 h-height_program_home_mb  md:h-[111px] lg:h-height_program_home width_program_shoes ";
export const STLE_PROGRAM_MYSHOES_DISABLE =
  "  flex gap-3 md:justify-center md:gap-6 text-left  p-[14px]  xl:py-4 xl:px-3.5 2xl:px-[54px] items-center rounded-2xl text-laundry-gray-50 w-full cursor-pointer  bg-laundry-gray-30 shadow-lg w-full md:w-[330px] lg:w-[407px] xl:w-program_home     row-span-2 h-height_program_home_mb md:h-height_program_home ";
export const STLE_PROGRAM_HOME_MYSHOES_DISABLE =
  " flex gap-3 md:justify-center md:gap-6 text-left  p-[14px]  xl:py-4 xl:px-3.5 2xl:px-[54px] items-center rounded-2xl text-laundry-gray-50 bg-laundry-gray-30  shadow-lg w-full md:w-[280px] lg:w-[398px] xl:w-program_home  row-span-2 h-height_program_home_mb  md:h-[111px] lg:h-height_program_home width_program_shoes ";

export const STYLE_PROGRAM_ICON_HOME =
  " my-auto md:mx-auto w-w_62_32 h-12 md:w-[67px] md:h-[67px] lg:w-icon_home lg:h-fit ";
export const STYLE_ICON_HOME_IRON =
  " w-w_62_32 h-12 md:h-[56px] lg:h-h_100 md:w-auto ";
export const STYLE_ICON_HOME_SHOES =
  " w-w_62_32 h-h_51_51 md:w-[67px] md:h-[67px] lg:w-icon_home lg:h-full";

export const STYLE_PROGRAM_NAME_HOME = (language) => {
  if (language === "TH") {
    return " text-base-th xl:text-lg-th font-bold";
  } else {
    return " text-base xl:text-lg font-bold";
  }
};
export const STYLE_PROGRAM_DESCRIPTION_HOME = (language) => {
  if (language === "TH") {
    return " text-xs-th md:text-sm-th xl:text-base-th md:w-2/3 mx-auto";
  } else {
    return " text-xs md:text-sm xl:text-base md:w-2/3 mx-auto";
  }
};
export const STYLE_UNDERLINE_BLUE =
  " w-border_blue my-5 mx-auto border-b-2 border-laundry-primary-blue";
export const STYLE_UNDERLINE_BLUE_SELECTPROGRAM =
  " w-10 md:w-border_blue my-3.5 md:my-6 mx-auto border-b-2 border-laundry-primary-blue";
export const STYLE_UNDERLUBE_BLUE_CONTACTUS =
  "w-10 md:w-border_blue my-4 mx-auto border-b-2 border-laundry-primary-blue";
export const STTYLE_UNDERLINE_BLUE_LEFT =
  "w-16 md:w-border_blue  border-b-2 border-laundry-primary-blue";
export const STYLE_UNDERLINE_BLUE_24_16 =
  "w-[45px] md:w-border_blue my-4 md:my-6 mx-auto border-b-2 border-laundry-primary-blue";
export const STYLE_DES_HOWITWORKS = (language) => {
  if (language === "TH") {
    return "text-center text-sm-th md:text-base-th text-laundry-gray-100";
  } else {
    return "text-center text-sm md:text-base text-laundry-gray-100";
  }
};

export const STYLE_IMG_SECTION = " w-60 md:w-img_faq_home ";
export const STYLE_IMG_MB_HIW =
  " w-img_howitwork_mb h-img_howitwork_mb mx-auto mt-[30px] md:mt-0 ";
export const STYLE_SPACE_SECTION_HIW = (language) => {
  if (language === "TH") {
    return " p-3 flex gap-4 ";
  } else {
    return " p-4 flex gap-4 ";
  }
};
export const STYLE_BUTTON_HIW =
  " w-button_hiw md:w-button mx-auto pt-4 md:pt-10 ";

export const STYLE_HOME_WELCOME_MB =
  "flex justify-between items-center px-4 mb-2";

export const STYLE_GRID_HOME_FAQ =
  " block md:grid md:grid-cols-2  px-4 md:px-10 xl:px-37 py-10 md:py-13 ";

export const STYLE_TITLE_HOME_FAQ = (language) => {
  if (language === "TH") {
    return "text-laundry-gray-100 font-semibold text-sm-th md:text-base-th leading-6 cursor-pointer w-[319px] md:w-5/6";
  } else {
    return "text-laundry-gray-100 font-semibold text-sm md:text-base leading-6 cursor-pointer w-[319px] md:w-5/6";
  }
};
export const STYLE_ICON_HOME_FAQ =
  "w-6 text-laundry-primary-blue cursor-pointer";

export const STYLE_DES_HOME_WELCOME = (language) => {
  if (language === "TH") {
    return "text-center text-xs-th md:text-base-th text-laundry-gray-100 pt-6 pb-5 md:pt-[31px] md:pb-0 leading-6";
  } else {
    return "text-center text-xs md:text-base text-laundry-gray-100 pt-6 pb-5 md:pt-[31px] md:pb-0 leading-6";
  }
};
export const STYLE_WASH_IRON_CLEAN_HOME_WELCOME = (language) => {
  if (language === "TH") {
    return "text-center text-laundry-gray-100 font-bold text-base-th md:text-lg-th md:leading-6";
  } else {
    return "text-center text-laundry-gray-100 font-bold text-base md:text-lg md:leading-6";
  }
};
export const STYLE_AVALIABLE_HOME_WELCOME = (language) => {
  if (language === "TH") {
    return "text-center text-laundry-primary-blue text-sm-th md:text-base-th flex justify-center pt-[4px] leading-6";
  } else {
    return "text-center text-laundry-primary-blue text-sm md:text-base flex justify-center pt-[4px] leading-6";
  }
};
export const STYLE_PADDING_LAUNDRY_SERVICE = " mt-5 md:mt-20 text-center";

export const STYLE_TEXT_UNDERLINE_BLUE =
  "  text-laundry-primary-blue underline ";

export const STYLE_WIDTH_CONTENT = "  xl:w-faq_home_section";

// export const STYLE_DES_LAUNDRY_SERVICE =
//   "text-sm md:text-base leading-6 text-laundry-gray-100 px-4 md:px-10 xl:px-padding_read";

export const STYLE_DES_LAUNDRY_SERVICE = (language) => {
  if (language === "TH") {
    return "text-sm-th md:text-base-th leading-6 text-laundry-gray-100 px-4 md:px-10 xl:px-[250px]";
  } else {
    return "text-sm md:text-base leading-6 text-laundry-gray-100 px-4 md:px-10 xl:px-padding_read";
  }
};

//CONTACT
export const STYLE_SPACE_LIST_CONTACTUS =
  " mt-6.5 md:mt-10 space-y-10 md:space-y-[60px] px-4 ";
export const STYLE_BORDER_ICON_CONTACT =
  " h-10 md:h-8 border border-laundry-border p-1 rounded-xl md:rounded-md";
export const STYLE_ICON_WHATSAPP =
  " h-10 md:h-8 bg-gradient-to-t  from-laundry-linedarkgrren  via-laundry-linedarkgrren to-laundry-linelightgreen p-2 md:p-1.5 rounded-xl md:rounded-md";
export const STYLE_ICON_WECHAT =
  " h-10 md:h-8 bg-laundry-wechatbg p-1 md:p-0.5 rounded-lg md:rounded-md";
export const STYLE_ICON_KAKAO =
  " h-10 md:h-8 text-laundry-kakaobrown bg-laundry-kakaoyellow rounded-xl md:rounded-md p-0.5";
export const STYLE_ICON_LINE =
  "h-8 bg-laundry-linebg p-0.5 rounded-md text-white";
export const STYLE_ICON_SIGNAL =
  " h-10 md:h-8 bg-laundry-signalbg p-1.5 rounded-xl md:rounded-md";
export const STYLE_ICON_CONTACT_US = "w-8 h-8 cursor-pointer";
export const STYLE_ICON_CONTACT_US_DISABLE = "w-8 h-8 ";

export const STYLE_TEXT_CONTACT = (language) => {
  if (language === "TH") {
    return "text-center text-laundry-gray-100 text-sm-th md:text-lg-th leading-6";
  } else {
    return " text-center text-laundry-gray-100 text-sm md:text-base leading-6";
  }
};
export const STYLE_TEXT_CONTACT_MEDIUM = (language) => {
  if (language) {
    return " text-laundry-gray-100 font-medium text-base-th md:text-lg-th ";
  } else {
    return " text-laundry-gray-100 font-medium text-base md:text-lg ";
  }
};

export const STYLE_IMG_BANNER_FAQ =
  "h-[187px] border-none md:h-img_banner mx-auto absolute bottom-0 left-1/2 transform -translate-x-1/2";

export const STYLE_IMG_BANNER_BKK =
  "border-none h-[201px] md:h-img_banner mx-auto absolute -bottom-0.5 left-1/2 transform -translate-x-1/2";

//SELECT PROGRAM
export const STYLE_TITLE_SELECTPROGRAM = (language) => {
  if (language === "TH") {
    return "font-bold text-laudry-gray-200 text-xl-th md:text-28-th flex items-center justify-center gap-1 md:gap-2";
  } else {
    return "font-bold text-laudry-gray-200 text-xl md:text-28 flex items-center justify-center gap-1 md:gap-2";
  }
};

//MORE
export const STYLE_MORE_BOX = (language) => {
  if (language === "TH") {
    return " bg-white md:bg-laundry-bglight md:hover:shadow-laundry-border md:hover:shadow-md md:hover:text-laundry-gray-80 duration-0 p-4 flex items-center gap-3 text-laudry-gray-200 font-semibold rounded-lg mb-2 cursor-pointer text-sm-th md:text-base-th";
  } else {
    return " bg-white md:bg-laundry-bglight md:hover:shadow-laundry-border md:hover:shadow-md md:hover:text-laundry-gray-80 duration-0 p-4 flex items-center gap-3 text-laudry-gray-200 font-semibold rounded-lg mb-2 cursor-pointer text-sm md:text-base";
  }
};
export const STYLE_ICON_MORE = "h-6";
export const STYLE_MORE_LIST =
  " px-4 py-2 md:px-10 md:pb-10 md:pt-4 md:py-0 space-y-2 bg-laundry-bglight md:bg-white rounded-b-xl min-h-screen md:min-h-full md:shadow-md shadow-laudry-shadowcard";
export const STYLE_COLSPAN_TERM =
  " col-span-5 md:col-span-1 text-left md:text-center pl-4 ";
export const STYLE_COLSPAN_PRIVACY =
  "col-span-5 md:col-span-1 text-left md:text-center pl-10";

//PROGRAM
//////////////////////////////////
// 8 รายการนี้ เราเอา -th ออก ที่ font size เพราะมันเหลือแต่ตัวเลขแล่ะ

export const STYLE_SIZE_BUTTON_MYWASH = (language) => {
  if (language === "TH") {
    return " bg-laundry-mywash rounded-full text-center text-white font-semibold text-sm-th shadow-md shadow-laundry-shadowblue  duration-0 h-h_34 flex justify-center items-center";
  } else {
    return " bg-laundry-mywash rounded-full text-center text-white font-semibold text-sm shadow-md shadow-laundry-shadowblue  duration-0 h-h_34 flex justify-center items-center";
  }
};

export const STYLE_SIZE_BUTTON_MYIRON = (language) => {
  if (language === "TH") {
    return "bg-laundry-myiron rounded-full text-center  text-white font-semibold text-sm-th shadow-md shadow-laundry-shadowblue  duration-0 h-h_34 flex justify-center items-center";
  } else {
    return "bg-laundry-myiron rounded-full text-center  text-white font-semibold text-sm shadow-md shadow-laundry-shadowblue  duration-0 h-h_34 flex justify-center items-center";
  }
};
export const STYLE_SIZE_BUTTON_MYDRY = (language) => {
  if (language === "TH") {
    return "bg-laundry-mydryclean rounded-full text-center  text-white font-semibold text-sm-th shadow-md shadow-laundry-shadowyellow  duration-0 h-h_34 flex justify-center items-center ";
  } else {
    return "bg-laundry-mydryclean rounded-full text-center  text-white font-semibold text-sm shadow-md shadow-laundry-shadowyellow  duration-0 h-h_34 flex justify-center items-center ";
  }
};
export const STYLE_SIZE_BUTTON_MYSHOES = (language) => {
  if (language === "TH") {
    return "bg-laundry-myshoes rounded-full text-center  text-white font-semibold text-sm-th shadow-md shadow-laundry-shadowpink  duration-0 h-h_34 flex justify-center items-center";
  } else {
    return "bg-laundry-myshoes rounded-full text-center  text-white font-semibold text-sm shadow-md shadow-laundry-shadowpink  duration-0 h-h_34 flex justify-center items-center";
  }
};

export const STYLE_SIZE_INACTIVE_MYWASH = (language) => {
  if (language === "TH") {
    return "text-laundry-gray-50 text-sm-th duration-0 h-h_34 flex justify-center items-center  rounded-full md:hover:text-laundry-mywash md:hover:font-bold ";
  } else {
    return "text-laundry-gray-50 text-sm duration-0 h-h_34 flex justify-center items-center  rounded-full md:hover:text-laundry-mywash md:hover:font-bold ";
  }
};
export const STYLE_SIZE_INACTIVE_MYIRON = (language) => {
  if (language === "TH") {
    return "text-laundry-gray-50 text-sm-th duration-0 h-h_34 flex justify-center items-center  rounded-full md:hover:text-laundry-myiron md:hover:font-bold ";
  } else {
    return "text-laundry-gray-50 text-sm duration-0 h-h_34 flex justify-center items-center  rounded-full md:hover:text-laundry-myiron md:hover:font-bold ";
  }
};

export const STYLE_SIZE_INACTIVE_MYSHOES = (language) => {
  if (language === "TH") {
    return "text-laundry-gray-50 text-sm-th duration-0 h-h_34 flex justify-center items-center  rounded-full md:hover:text-laundry-myshoes md:hover:font-bold ";
  } else {
    return "text-laundry-gray-50 text-sm duration-0 h-h_34 flex justify-center items-center  rounded-full md:hover:text-laundry-myshoes md:hover:font-bold ";
  }
};
export const STYLE_SIZE_INACTIVE_MYDRY = (language) => {
  if (language === "TH") {
    return "text-laundry-gray-50 text-sm-th duration-0 h-h_34 flex justify-center items-center  rounded-full md:hover:text-laundry-mydryclean md:hover:font-bold ";
  } else {
    return "text-laundry-gray-50 text-sm duration-0 h-h_34 flex justify-center items-center  rounded-full md:hover:text-laundry-mydryclean md:hover:font-bold ";
  }
};

/////////////////////////////////

export const STYLE_SIZE_INACTIVE = (language) => {
  if (language === "TH") {
    return "text-laundry-gray-50 text-sm-th duration-0 h-h_34 flex justify-center items-center  rounded-full md:hover:text-laundry-primary-blue md:hover:font-bold ";
  } else {
    return "text-laundry-gray-50 text-sm duration-0 h-h_34 flex justify-center items-center  rounded-full md:hover:text-laundry-primary-blue md:hover:font-bold ";
  }
};

export const STYLE_SIZE_INACTIVE_PRICING = (language) => {
  if (language === "TH") {
    return "text-laundry-gray-50 text-sm-th duration-0 h-h_34 flex justify-center items-center  rounded-full md:hover:bg-laundry-gray-50 md:hover:text-white";
  } else {
    return "text-laundry-gray-50 text-sm duration-0 h-h_34 flex justify-center items-center  rounded-full md:hover:bg-laundry-gray-50 md:hover:text-white";
  }
};

export const STYLE_PRICE_SIZE = (language) => {
  if (language === "TH") {
    return " text-[32px] md:text-40-th text-center font-bold text-laudry-gray-200 leading-8.5";
  } else {
    return " text-[30px] md:text-40 text-center font-bold text-laudry-gray-200 leading-8.5";
  }
};

export const STYLE_TAB_SIZE =
  "border border-laudry-stroke rounded-full px-1  grid grid-cols-3 items-center text-center h-creatorder_navbar my-4";
export const STYLE_FLEX_INFO =
  "flex justify-center pt-2 md:pt-4 items-center gap-1 ";
export const STYLE_PARENT_GRID_ADDONS =
  "grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-x-20 md:gap-y-3.5 mb-2";
export const STYLE_GRID_ADDONS =
  " group border border-[#DADADA] rounded-lg flex justify-between p-3 cursor-pointer ";

export const STYLE_COLSPAN_ADDONS = " col-span-8 md:col-span-9";
export const STYLE_TITLE_ADDON = (language) => {
  if (language === "TH") {
    return " group-hover:underline text-laudry-gray-200 font-semibold text-sm-th md:text-base-th leading-6 break-all";
  } else {
    return " group-hover:underline text-laudry-gray-200 font-semibold text-sm md:text-base leading-6 break-all";
  }
};
export const STYLE_DES_ADDON = (language) => {
  if (language === "TH") {
    return "text-laundry-gray-80 text-xs-th md:text-sm-th leading-6 font-normal";
  } else {
    return "text-laundry-gray-80 text-xs md:text-sm leading-6 font-normal";
  }
};
export const STYLE_PRIZE_ADDON = (language) => {
  if (language === "TH") {
    return "text-laundry-gray-100 font-semibold  text-right text-sm-th md:text-base-th leading-6";
  } else {
    return "text-laundry-gray-100 font-semibold  text-right text-sm md:text-base leading-6";
  }
};
export const STYLE_ACTIVE_ADDON =
  " border rounded-lg flex justify-between p-2 cursor-pointer ";
export const STYLE_ACTIVE_ADDON_MYWASH =
  " bg-laundry-primary-blue-10 border border-laundry-primary-blue rounded-lg flex justify-between p-3 cursor-pointer ";
export const STYLE_ACTIVE_ADDON_MYIRON =
  "bg-laundry-addons_myiron border border-laundry-stroke_myiron rounded-lg flex justify-between p-3 cursor-pointer";
export const STYLE_ACTIVE_ADDON_MYSHOES =
  " bg-laundry-addons_myshoes border border-laundry-stroke_myshoes rounded-lg flex justify-between p-3 cursor-pointer";

export const STYLE_BG_WHITE_PROGRAM_HEAD =
  " bg-white p-4 md:px-6 md:pt-6 md:pb-0  w-full rounded-2xl md:rounded-t-lg md:rounded-b-none mb-4 md:my-0  ";
export const STYLE_BG_PROGRAM_SELECT_ADDON =
  " bg-white md:p-6  xl:pb-[30px] xl:pt-6 w-full rounded-2xl md:rounded-b-lg md:rounded-t-none md:shadow-xl md:shadow-laudry-shadowcard  ";

export const STYLE_CIRCLE_PROGRAM =
  "rounded-full h-12 w-12  md:w-16 md:h-16 xl:w-20 xl:h-20 ";

export const STYLE_TITLE_ADDONS = (language) => {
  if (language === "TH") {
    return "text-laundry-gray-200 text-base-th md:text-lg-th font-medium h-9 flex items-end my-[12px] md:mb-3 md:mt-5";
  } else {
    return "text-laundry-gray-200 text-base md:text-lg font-medium h-9 flex items-end my-[12px] md:mb-3 md:mt-5";
  }
};
export const STYLE_BG_TOPBAR_PROGRAM =
  " py-2.5 bg-white h-16  w-full shadowbar fixed top-0 z-50  ";

export const STYLE_TOPBAR_PROGRAM = "relative w-full";

//BUSKET
export const STYLE_INPUT_BUSKET =
  " bg-transparent w-full h-10 border-none  rounded-md placeholder:text-laundry-gray-50 text-laundry-100 px-2 text-sm focus:outline-none ";

export const STYLE_TEXTAREA_BUSKET = (language) => {
  if (language === "TH") {
    return " font-NotoSansThai w-full  border border-laudry-stroke rounded-md placeholder:text-laundry-gray-50 text-laundry-100 p-p_14 md:py-2 md:px-3  text-13-th md:text-base-th focus:outline-none  leading-5 md:leading-6 ";
  } else {
    return " font-Poppins w-full  border border-laudry-stroke rounded-md placeholder:text-laundry-gray-50 text-laundry-100 p-p_14 md:py-2 md:px-3  text-13 md:text-base focus:outline-none  leading-5 md:leading-6 ";
  }
};

export const STYLE_BORDER_BUSKET = " border-b border-[#D0D3E5] w-full my-4";

export const STYLE_DETAILS_ADDONS_BUSKET = (language) => {
  if (language === "TH") {
    return " text-sm-th md:text-base-th text-laundry-gray-100 font-medium flex justify-between ";
  } else {
    return " text-sm md:text-base text-laundry-gray-100 font-medium flex justify-between ";
  }
};

export const STYLE_DETAILS_ADDONS_BUSKET_ORDER = (language) => {
  if (language === "TH") {
    return " text-sm md:text-base text-laundry-gray-100 font-medium flex justify-between ";
  } else {
    return " text-sm md:text-base text-laundry-gray-100 font-medium flex justify-between ";
  }
};

export const STYLE_EDIT_BUSKET = (language) => {
  if (language === "TH") {
    return "h-5 text-laundry-primary-blue  duration-0 font-semibold cursor-pointer mx-2 text-xs-th md:text-base-th md:hover:text-laundry-gray-80";
  } else {
    return "h-5 text-laundry-primary-blue  duration-0 font-semibold cursor-pointer mx-2 text-xs md:text-base md:hover:text-laundry-gray-80";
  }
};

export const STYLE_EDIT_BUSKET_ADDRESS = (language) => {
  if (language === "TH") {
    return "h-5 text-laundry-primary-blue  duration-0 font-semibold cursor-pointer mx-2 text-[16px] md:text-base-th md:hover:text-laundry-gray-80";
  } else {
    return "h-5 text-laundry-primary-blue  duration-0 font-semibold cursor-pointer mx-2 text-[14px] md:text-base md:hover:text-laundry-gray-80";
  }
};

export const STYLE_EDIT_BUSKET_DISABLE = (language) => {
  if (language === "TH") {
    return "text-gray-500  duration-0 font-semibold cursor-pointer mx-2 text-xs-th md:text-base-th ";
  } else {
    return "text-gray-500  duration-0 font-semibold cursor-pointer mx-2 text-xs md:text-base ";
  }
};
export const STYLE_DELETE_BUSKET = (language) => {
  if (language === "TH") {
    return " text-xs-th md:text-base-th text-laundry-red-100   duration-0 font-semibold cursor-pointer md:hover:text-laundry-gray-80";
  } else {
    return " text-xs md:text-base text-laundry-red-100   duration-0 font-semibold cursor-pointer md:hover:text-laundry-gray-80";
  }
};

export const STYLE_SECTION_ORER_DETIALS = "flex justify-between mt-2";

export const STYLE_DELETE_BUSKET_DISABLED = (language) => {
  if (language === "TH") {
    return " text-xs-th md:text-base-th text-gray-300 duration-0 font-semibold cursor-pointer";
  } else {
    return " text-xs md:text-base text-gray-300 duration-0 font-semibold cursor-pointer";
  }
};
export const STYLE_PICKUP_ORDER = (language) => {
  if (language === "TH") {
    return " text-xs-th md:text-sm-th text-laundry-gray-100 font-medium leading-6";
  } else {
    return " text-xs md:text-sm text-laundry-gray-100 font-medium leading-6";
  }
};
export const STYLE_BORDER_BUSKET_POPUP = "border-b border-laudry-stroke py-1";

export const STYLE_DATE_DISABLED =
  " border border-laundry-gray-10 text-laudry-stroke font-medium  ";

export const STYLE_DATE_SELECTED = " text-white bg-laundry-primary-blue  ";

export const STYLE_DATE_NORMAL =
  " border border-[#D9DBE9] text-laundry-gray-100 cursor-pointer  hover:border-laundry-primary-blue  ";

export const STYLE_DATE_COMMON = (language) => {
  if (language === "TH") {
    return " text-sm-th font-medium p-3 px-2 rounded-[10px] cursor-pointer  md:w-[105px] text-center flex-none ";
  } else {
    return " text-sm font-medium p-3 px-2 rounded-[10px] cursor-pointer  md:w-[105px] text-center flex-none";
  }
};
export const STYLE_NAME_DATE = (language) => {
  if (language === "TH") {
    return "font-medium  text-sm-th text-center text-laundry-100";
  } else {
    return "font-medium  text-sm text-center text-laundry-100";
  }
};

export const STYLE_FULLDATE = (language) => {
  if (language === "TH") {
    return "font-normal text-sm-th text-center text-laundry-80";
  } else {
    return "font-normal text-sm text-center text-laundry-80";
  }
};

export const STYLE_PARENT_POPUP =
  " flex space-x-1 p-2 md:p-4 overflow-x-scroll  ";
export const STYLE_ICON_WATER =
  "shadow-none w-14 h-14 2xl:w-16 2xl:h-16 3xl:w-20 3xl:h-20";
export const STYLE_COMMON_ICON_PROGRAM =
  " p-2 rounded-lg shadow-lg w-14 h-14  xl:w-border_blue xl:h-border_blue 2xl:w-16 2xl:h-16  3xl:w-20 3xl:h-20 ";
export const STYLE_GRID_ORDER_PROGRAM =
  "grid grid-cols-5 md:grid-cols-10 xl:grid-cols-12  border-b-[1.5px] border-borderbottomline py-1 md:py-4 ";
export const STYLE_COLSPAN_ORDER_PROGRAM =
  "col-span-4 md:col-span-9 xl:col-span-11";
export const STYLE_PARENT_DELETE_PROGRAM =
  " p-4 md:p-6 h-44 md:h-h_220 w-modalsmobile md:w-modals font-Poppins";
export const STYLE_POPUP_ADD_PROGRAM =
  "grid grid-cols-6 md:grid-cols-1 p-4 gap-1 rounded-lg md:rounded-2xl text-laundry-gray-100 md:text-center w-full cursor-pointer md:mx-auto md:h-52";
export const STYLE_TEXT_POPUP_ADD_PROGRAM =
  "col-span-5 text-left md:text-center";
export const STYLE_IMG_POPUP_ADD_PROGRAM =
  "col-span-1 my-auto mx-auto h-10  md:h-24 xl:h-24 ";
export const STYLE_PARENT_PROGRAM_SIZE = "flex justify-between my-0";

//ORDER
export const STYLE_TITLE_ORDER_NAME = (language) => {
  if (language === "TH") {
    return " w-full  text-sm-th md:text-base-th font-semibold text-laundry-gray-100 md:leading-6";
  } else {
    return " text-sm md:text-base font-semibold text-laundry-gray-100 md:leading-6";
  }
};
export const STYLE_TITLE_ORDER_NAME_DETAILS = (language) => {
  if (language === "TH") {
    return "  text-xs-th md:text-base-th  font-semibold text-laundry-gray-100 md:leading-6";
  } else {
    return " text-xs md:text-base font-semibold text-laundry-gray-100 md:leading-6";
  }
};

export const STYLE_DATE_ORDER = (language) => {
  if (language === "TH") {
    return "text-laundry-gray-80 text-13-th md:text-sm-th font-normal leading-5 md:leading-6 items-center my-auto <24>";
  } else {
    return "text-laundry-gray-80 text-13 md:text-sm font-normal leading-5 md:leading-6 items-center my-auto <24>";
  }
};
export const STYLE_DATE_ORDER_DETAILS = (language) => {
  if (language === "TH") {
    return "text-laundry-gray-80 text-xs-th md:text-sm-th font-normal leading-5 md:leading-6";
  } else {
    return "text-laundry-gray-80 text-xs md:text-sm font-normal leading-5 md:leading-6";
  }
};
export const STYLE_INPROCESS = (language) => {
  if (language === "TH") {
    return " mx-auto w-28 md:w-36 bg-[#FFF4CA] text-[#FFB906]  flex justify-center items-center p-2 h-full md:px-[10px] md:py-[6px] md:h-9 rounded-full font-medium text-xs-th md:text-sm-th";
  } else {
    return " mx-auto w-28 md:w-36 bg-[#FFF4CA] text-[#FFB906]  flex justify-center items-center p-2 h-full md:px-[10px] md:py-[6px] md:h-9 rounded-full font-medium text-xs md:text-sm";
  }
};
export const STYLE_COMPLETE = (language) => {
  if (language === "TH") {
    return "mx-auto w-28 md:w-36 bg-laundry-bgcompleted text-laundry-completed flex justify-center items-center p-2 h-full md:h-9 rounded-full font-medium text-xs-th md:text-sm-th ";
  } else {
    return "mx-auto w-28 md:w-36 bg-laundry-bgcompleted text-laundry-completed flex justify-center items-center p-2 h-full md:h-9 rounded-full font-medium text-xs md:text-sm ";
  }
};
export const STYLE_CENCELED = (language) => {
  if (language === "TH") {
    return " mx-auto w-28 md:w-36 bg-laundry-bgcanceled text-laundry-canceled flex justify-center items-center p-2 h-full md:h-9 rounded-full font-medium text-xs-th md:text-sm-th ";
  } else {
    return " mx-auto w-28 md:w-36 bg-laundry-bgcanceled text-laundry-canceled flex justify-center items-center p-2 h-full md:h-9 rounded-full font-medium text-xs md:text-sm ";
  }
};

export const STYLE_CARD_ORDER =
  " md:bg-laudry-graycard w-full h-full p-4 md:p-6 rounded-lg shadow-lg shadow-laundry-shadowbg md:my-4";
export const STYLE_SECTION_ORDER = "group cursor-pointer py-4";
export const STYLE_BORDER_SECTION_ORDER = " border-b border-b-[#D9DBE9]";
export const STYLE_PAYMENT_ORDER = "  flex gap-2 ";
export const STYLE_QUESTION_ORDER_BG =
  " bg-white  p-2.5 md:p-6 rounded-b-xl text-center";
export const STYLE_IMG_BANNER_ORDER =
  "border-none  h-[197.31px] md:h-img_banner mx-auto absolute bottom-[4px] md:bottom-0 left-1/2 transform -translate-x-1/2  ";

export const STYLE_BOTTOM_ORDER = (language) => {
  if (language === "TH") {
    return " text-[16px] text-laundry-gray-100 leading-6 h-11 md:pb-[32px]  text-center rounded-b-xl bg-white flex justify-center items-center";
  } else {
    return " text-[14px] md:text-[16px] text-laundry-gray-100 leading-6 h-11 md:pb-[32px]  text-center rounded-b-xl bg-white flex justify-center items-center";
  }
};

export const STYLE_TEXTAREA_SPECIAL_REQUEST =
  "bg-transparent w-full h-14 border-none rounded-md placeholder:text-laundry-gray-50 text-laundry-100 px-2 text-base focus:outline-none";

export const STYLE_TEXTAREA_SPECIAL_REQUEST_2 = (language) => {
  if (language === "TH") {
    return "w-full border border-laudry-stroke rounded-md placeholder:text-laundry-gray-50 text-laundry-100  py-2 px-3 text-13-th md:text-base-th focus:outline-none mb-2 md:mb-6 leading-5 md:leading-6 ";
  } else {
    return "w-full border border-laudry-stroke rounded-md placeholder:text-laundry-gray-50 text-laundry-100 py-2 px-3 text-13 md:text-base focus:outline-none mb-2 md:mb-6 leading-5 md:leading-6 ";
  }
};

export const STYLE_HEAD_PICK_DATE_AND_TIME = (language) => {
  if (language === "TH") {
    return "text-sm-th md:text-base-th text-laundry-gray-100 font-semibold pt-6 pb-2 px-4 md:px-6 text-left";
  } else {
    return "text-sm md:text-base text-laundry-gray-100 font-semibold md:pb-3 pt-6 px-4 md:px-6 text-left";
  }
};

//BAR
export const STYLE_BOTTOM_BAR =
  " w-full px-4 md:px-10 xl:px-padding_read pt-4 md:py-8 bg-white ";
export const STYLE_TOTAL_BAR =
  "w-full px-4 md:px-10 xl:px-padding_read pt-4 pb-10 md:py-10 bg-white fixed bottom-0  shadowbottom";
export const STYLE_LOGIN_BAR =
  " w-full px-4 md:px-10 xl:px-padding_read pt-4  md:py-8 bg-white md:shadowbottom ";
export const STYLE_FIXED_BAR =
  " w-full px-4 md:px-10 xl:px-padding_read pt-4  md:py-8";
//IMG-EMPTY
export const STYLE_IMG_EMPTY =
  " w-[160px] h-[140px] mx-auto mt-69 md:mt-6.5 mb-6.5 md:mb-8";
export const STYLE_IMG_EMPTY_BASKET =
  " w-[123px] h-[107px] mx-auto mt-69 md:mt-6.5 mb-[36px] md:mb-8";
export const STYLE_IMG_EMPTY_ORDER =
  " w-w_125 h-h_105 mx-auto mt-69 md:mt-6.5 mb-6.5 md:mb-5 ";

//ADDRESS
export const STYLE_ICON_ADDRESS = " w-[18px] mx-auto mt-1 ";
export const STYLE_ICON_BLUE =
  "bg-laundry-primary-blue w-[26px] h-[26px] rounded-full  mt-[4px] flex-none";
export const STYLE_PARENT_SELECT_ADDRESS = " flex py-4 gap-3 md:gap-4 group";
export const STYLE_PARENT_SELECT_ADDRESS_BASKET =
  "grid grid-cols-8 md:grid-cols-12 border-b border-laudry-stroke py-4 gap-2 ";
export const STYLE_COLSPAN_ADDRESS = " flex-shrink cursor-pointer ";
export const STYLE_COLSPAN_ADDRESS_BASKET =
  " col-span-6 md:col-span-10 space-y-2";
export const STYLE_SEARCH_ADDRESS =
  "border-none bg-transparent h-[10px] md:h-h_50 w-full rounded-r-md focus:outline-none px-[2px] font-medium placeholder:text-laudry-gray-50 text-laudry-gray-200 ";
export const STYLE_SEARCH_ADDRESS_ICON = " w-6 h-6 text-[#3AB4ED]";
export const STYLE_PARENT_SEARCH_ADDRESS =
  "flex justify-between border-b border-b-laudry-stroke h-19 md:h-20 cursor-pointer md:pr-[4px] gap-3.5 py-[14px] md:py-0 my-";
export const STYLE_ADDRESS_FOUND =
  "w-full flex gap-[14px] md:gap-3 items-center group h-fit my-auto c3";
export const STYLE_ADDRESS_ICON_BLUE_CIRCLE =
  "bg-laundry-primary-blue rounded-full w-[26px] h-auto md:w-6 md:h-6 p-1";
export const STYLE_ADDRESS_BG =
  "  bg-white  md:ordershadow px-4 md:px-6 md:pb-[30px] rounded-xl h-full relative";
export const STYLE_ORDER_BG =
  "  bg-white  md:ordershadow px-4 md:px-6 rounded-xl rounded-b-none h-full";
export const STYLE_ADDRESS_BG_BASKET = " bg-white rounded-xl p-4 ";
export const STYLE_BORDER_INPUT_ADDRESS =
  "bg-white border-laundry-borderinput rounded-lg w-full h-14 border-2 flex justify-center items-center mt-3 md:mt-4";
export const STYLE_PARENT_ADDRESS_GOOGLEMAP =
  " absolute z-20 md:left-12 lg:left-[34px]  xl:left-[169px]  md:top-6 px-4 ";
export const STYLE_BG_ICON_BASKET =
  "bg-laundry-primary-blue w-8 h-8 rounded-full mt-2";
export const STYLE_ICON_FOR_BASKET = "w-5 my-1.5 mx-auto";

export const STYLE_PARENT_ADDRESS = (language) => {
  if (language === "TH") {
    return "flex items-center gap-1 md:gap-0 text-laudry-gray-200 font-medium text-sm-th xl:text-base-th w-full leading-6  border border-laudry-stroke rounded-[10px] h-10 md:h-h_50 px-2";
  } else {
    return "flex items-center gap-1 md:gap-0 text-laudry-gray-200 font-medium text-sm xl:text-base w-full leading-6  border border-laudry-stroke rounded-[10px] h-10 md:h-h_50 px-2";
  }
};

export const STYLE_BOX_SEARCH = (language) => {
  if (language === "TH") {
    return "text-sm-th md:text-base-th font-Poppins font-medium text-laundry-gray-200 cursor-pointer md:hover:text-laundry-primary-blue md:hover:underline duration-0 line-clamp-2 py-1 leading-6";
  } else {
    return "text-sm md:text-base font-Poppins font-medium text-laundry-gray-200 cursor-pointer md:hover:text-laundry-primary-blue md:hover:underline duration-0 line-clamp-2 py-1 leading-6";
  }
};

export const STYLE_PARENT_BOX_SEARCH =
  "absolute top-[56px] lg:left-[0px] xl:left-[75px] rounded-xl bg-white border border-laudry-stroke divide-y divide-laundry-border p-4";

export const STYLE_SAVED_ADDRESSES =
  "text-black font-semibold text-sm md:text-base leading-6 h-6 md:h-10 flex items-center";
//FAQ

export const STYLE_DES_FAQ = (language) => {
  if (language === "TH") {
    return " text-xs-th md:text-base-th text-laundry-gray-80 mb-2 break-words";
  } else {
    return " text-xs md:text-base text-laundry-gray-80 mb-2 break-words";
  }
};

//GLOSSARY
export const STYLE_PARENT_TAB_ADDONS_GLOSSARY =
  "flex space-x-2 overflow-x-scroll pb-4";
export const STYLE_SELECTED_ADDON_TAB =
  "flex flex-shrink-0 border border-laundry-primary-blue text-laundry-primary-blue rounded-full h-h_34 items-center px-2.5 cursor-pointer font-bold";
export const STYLE_UNSELECT_ADDON_TAB =
  "flex flex-shrink-0 border border-laundry-gray-50 text-laundry-gray-50 md:hover:border-laundry-primary-blue md:hover:text-laundry-primary-blue rounded-full h-h_34 items-center px-2.5 cursor-pointer";

export const STYLE_SELECTED_PROGRAM_TAB =
  "flex flex-shrink-0 border border-laundry-primary-blue text-laundry-primary-blue rounded-full h-11 items-center cursor-pointer font-bold justify-center ";
export const STYLE_UNSELECT_PROGRAM_TAB =
  "flex flex-shrink-0 border border-laundry-gray-50 md:hover:border-laundry-primary-blue md:hover:text-laundry-primary-blue text-laundry-gray-50 rounded-full h-11 items-center cursor-pointer font-medium justify-center ";
export const STYLE_ALL_PROGRAM_TAB =
  " w-16 border border-laundry-gray-50 text-laundry-gray-50 rounded-full h-11 flex justify-center items-center px-2.5 cursor-pointer font-medium text-center";
export const STYLE_ALL_PROGRAM_TAB_SELECTED =
  " w-16 border border-laundry-primary-blue text-laundry-primary-blue rounded-full h-11 flex justify-center items-center px-2.5 cursor-pointer font-bold text-center";

//PRICING
export const STYLE_SIZE_BUTTON_PRICING = (language) => {
  if (language === "TH") {
    return " bg-laundry-gray-50 rounded-full text-center text-white font-semibold text-base-th shadow-md shadow-laundry-shadow-gray duration-0 h-h_34 flex justify-center items-center";
  } else {
    return " bg-laundry-gray-50 rounded-full text-center text-white font-semibold text-base shadow-md shadow-laundry-shadow-gray duration-0 h-h_34 flex justify-center items-center";
  }
};

//TEARM
export const STYLE_TITLE_TEARM_POLICY = (language) => {
  if (language === "TH") {
    return "font-bold text-laudry-gray-200 text-30-th md:text-28-th flex items-center justify-center gap-1 md:gap-2";
  } else {
    return "font-bold text-laudry-gray-200 text-30 md:text-28 flex items-center justify-center gap-1 md:gap-2";
  }
};
export const STYLE_TITLE_TEARM_POLICY_MB = (language) => {
  if (language === "TH") {
    return "font-bold text-laudry-gray-200 text-30-th md:text-28-th";
  } else {
    return "font-bold text-laudry-gray-200 text-30 md:text-28";
  }
};

//BKK
export const STYLE_IMG_BKK =
  " w-img_howitwork_mb mx-auto mb-4 md:w-img_faq_home md:h-img_faq_home md:mb-0 md:mx-0";
export const STYLE_PARENT_GRID_BKK = " md:flex gap-[120px] items-center ";

export const STYLE_BUTTON_BOTTOM_HIDDEN_SHOW =
  "w-full px-4 md:px-10 xl:px-padding_read pt-4  md:py-8 max-w-desktop mx-auto bg-white mt-4 -mb-10";

//TERM
export const STYLE_TITLE_NO_TERM =
  "text-laudry-gray-200 font-bold text-2xl leading-6.5";
export const STYLE_SUB_NO_TERM = "my-3 ml-3";
export const STYLE_UNDERLINE_BLUE_TERM =
  "text-laundry-primary-blue underline underline-offset-2";
export const STYLE_UNDERLINE_PRIVACY = "underline underline-offset-2";

export const STYLE_SCREEN_FULL =
  "flex flex-col justify-between min-h-[100svh] md:min-h-full overflow-x-hidden  md:bg-laundry-borderbottomline relative";

export const STYLE_SCREEN_FULL_WITH_FOOTER =
  "flex flex-col justify-between min-h-[100svh] md:min-h-full overflow-x-hidden  md:bg-laundry-borderbottomline relative";

export const STYLE_ABSOLUTE_OBJECT_CENTER =
  "absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2";
